import { render, staticRenderFns } from "./MapboxCoordinates.vue?vue&type=template&id=2a539898"
import script from "./MapboxCoordinates.vue?vue&type=script&lang=js"
export * from "./MapboxCoordinates.vue?vue&type=script&lang=js"
import style0 from "./MapboxCoordinates.vue?vue&type=style&index=0&id=2a539898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports